/**
 * An event's gallery as one list: its photos with its videos among them, each
 * video marked so a tile and the gallery know to play it.
 *
 * Both lists come in the same order -- the event's and its programme's, then
 * trail by trail as they are walked -- and are joined group by group: one video
 * opens a group, its photos follow, and any more videos close it. The first
 * video of all then leads the list, whichever group it is from: the first tiles
 * are all a page shows before the gallery is opened, and an event with photos
 * of its own would otherwise keep a trail's video out of sight behind them.
 */
import type { Photo } from "@/lib/types/event";

const OWN = "own";

const groupOf = (file: Photo) => file.trail_id ?? OWN;

export function galleryMedia(photos: Photo[] | null | undefined, videos: Photo[] | null | undefined): Photo[] {
  const stills = photos || [];
  if (!videos || videos.length === 0) {
    return stills;
  }
  const groups = new Map<number | string, { photos: Photo[]; videos: Photo[] }>();
  const group = (key: number | string) => {
    let found = groups.get(key);
    if (!found) {
      found = { photos: [], videos: [] };
      groups.set(key, found);
    }
    return found;
  };
  // the event's own come first, whichever list has them
  group(OWN);
  stills.forEach((photo) => group(groupOf(photo)).photos.push(photo));
  videos.forEach((video) => group(groupOf(video)).videos.push({ ...video, video: true }));

  const joined = [...groups.values()].flatMap(({ photos: own, videos: [first, ...rest] }) => [...(first ? [first] : []), ...own, ...rest]);
  const lead = joined.findIndex((file) => file.video);
  return lead > 0 ? [joined[lead], ...joined.slice(0, lead), ...joined.slice(lead + 1)] : joined;
}
